import { Component, Inject } from '@angular/core';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { RadioSettingsService } from '@se/platform';
import { ConfidentialityCodeType, ObscuredTabType } from 'estensa-module';
import { ObscuredData, ObscuredDataModalConfiguration, SpecialLaws, hasAnyTrueObscuredSpecialLaws } from './obscured-data.models';

@Component({
    selector: 'se-obscured-data',
    templateUrl: './obscured-data.component.html',
    styleUrls: ['./obscured-data.component.scss'],
    standalone: false
})
export class ObscuredDataComponent {
    customVisibility = this.data.customVisibility;
    images = this.data.images;
    readonly = this.data.readonly ?? false;
    obscuredData = { ...this.data.data };
    suggestions = this.data.suggestions;
    type = this.data.type;
    showTooltipConfidentiality = false;
    showTooltipObscuring = false;

    constructor(
        @Inject(MAT_DIALOG_DATA) private data: ObscuredDataModalConfiguration,
        public dialogRef: MatDialogRef<ObscuredDataComponent, ObscuredData>,
        private radiosetting: RadioSettingsService
    ) { }

    get hasSpecialLaws() {
        return this.type === ObscuredTabType.CustomVisibility || this.type === ObscuredTabType.FSE20;
    }

    get isDisabled() {
        // In caso di FSE2.0, i pulsanti non sono mai disabilitati.
        return this.readonly && this.type !== ObscuredTabType.FSE20;
    }

    get isDisabledFSE() {
        // In caso di FSE2.0, i pulsanti sono disabilitati se il referto è in stato "APROVE" e il Setting "canConfidentialityCodeBeModifiedPostApproval" è FALSE.
        return (this.readonly && this.type !== ObscuredTabType.FSE20) || !this.data.canFSEBeModified;
    }

    get showSaveButton() {
        return this.readonly && this.type === ObscuredTabType.FSE20;
    }

    onSpecialLawsChange(onCheck: MatCheckboxChange) {
        if (this.type === ObscuredTabType.FSE20) {
            const checked = onCheck.checked;
            const approved = this.readonly;
            const canModify = this.data.canFSEBeModified;

            const isEditable = !approved || canModify;

            const specialLawsKeys: (keyof ObscuredData)[] = [
                SpecialLaws.obscuredDrug,
                SpecialLaws.obscuredHIV,
                SpecialLaws.obscuredViolence,
                SpecialLaws.obscuredInterruption,
                SpecialLaws.obscuredReferringPhysician,
                SpecialLaws.obscuredAnonymityBirth,
                SpecialLaws.obscuredFamilyCounseling
            ];

            const hasSpecialLaws = hasAnyTrueObscuredSpecialLaws(this.obscuredData, specialLawsKeys);

            if (checked || hasSpecialLaws) {
                this.obscuredData.obscuredDocument = true;
                this.obscuredData.deObscuredDocument = false;

                if (isEditable) {
                    this.obscuredData.confidentialityCode = ConfidentialityCodeType.VeryRestricted;
                }
                return;
            }

            this.obscuredData.obscuredDocument = false;
            const shouldApplyDefaultConfidentialityCode =
                this.radiosetting.isConfidentialityCodeDefaultApply() && isEditable;
            if (shouldApplyDefaultConfidentialityCode) {
                this.obscuredData.confidentialityCode = ConfidentialityCodeType.Normal;
            }
        }
    }

    onDeObscuredDocument(onCheck: MatCheckboxChange) {
        const checked = onCheck.checked;
        if (checked && this.obscuredData.obscuredDocument) {
            this.obscuredData.obscuredDocument = false;
        }
    }

    onObscuredDocument(onCheck: MatCheckboxChange) {
        const checked = onCheck.checked;
        if (checked && this.obscuredData.deObscuredDocument) {
            this.obscuredData.deObscuredDocument = false;
        }
    }
}
